/**
 * Created by Fernando Torres on 01/02/2018.
 */
import BranchesListView from '@/views/app/branches/branches-list-view'
import BranchesView from '@/views/app/branches/branches-view'
import BranchesEditView from '@/views/app/branches/branches-edit-view'
import BranchesCreateView from '@/views/app/branches/branches-create-view'

export default [{
  path: 'branches',
  name: 'branches',
  component: BranchesListView,
  children: [{
    path: 'create',
    name: 'branches-create',
    component: BranchesCreateView
  },
  {
    path: 'branches/:id/edit',
    name: 'branches-edit',
    component: BranchesEditView
  }
  ]
},
{
  path: 'branches/:id',
  name: 'branches-view',
  component: BranchesView
}
]



// WEBPACK FOOTER //
// ./src/router/app/branches/index.js